// extracted by mini-css-extract-plugin
export default {"GeneralContainer":"General_GeneralContainer__k+pEy","form":"General_form__dsvd9","locationSelector":"General_locationSelector__qVvBz"};